import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ConcreteCategory, DevicesRouterStoreSelectors, LocationsRouterStoreSelectors } from '../router';
import * as fromReducer from './devices-os-update-status.reducer';
import { DeviceOsUpdateStatusState, OSUpdateStatus } from './devices-os-update-status.state';

export const selectDevicesOsUpdateStatusesState = createFeatureSelector<DeviceOsUpdateStatusState>(
  fromReducer.DevicesOsUpdateStatesFeatureKey
);

export const selectDevicesOsUpdateStatuses = createSelector(
  selectDevicesOsUpdateStatusesState,
  fromReducer.selectDevicesOsUpdateStatuses
);

export const selectDevicesOsUpdateStatusesIds = createSelector(
  selectDevicesOsUpdateStatusesState,
  fromReducer.selectDevicesOsUpdateStatusesIds
);

export const selectDevicesOsUpdateStatusesEntities = createSelector(
  selectDevicesOsUpdateStatusesState,
  fromReducer.selectDevicesOsUpdateStatusesEntities
);

export const selectOsUpdateStatusesByCategoryId = createSelector(
  selectDevicesOsUpdateStatuses,
  LocationsRouterStoreSelectors.selectCategory('Location'),
  (status: OSUpdateStatus[], category: ConcreteCategory<'Location'> | undefined) =>
    category ? status.filter((s) => s.categoryId === category.categoryId) : []
);

export const selectOsUpdateStatusByUdid = createSelector(
  selectDevicesOsUpdateStatusesState,
  DevicesRouterStoreSelectors.selectUdid,
  (state: DeviceOsUpdateStatusState, udid: string | null) => (udid ? state.entities[udid] : undefined)
);

export const selectOsUpdateStatusWithUdidParam = (udid: string) =>
  createSelector(selectDevicesOsUpdateStatusesState, (state: DeviceOsUpdateStatusState) => state.entities[udid]);
